/**
 * Created by alvinoktavianus on 6/7/17.
 */

import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import moment from 'moment'
import { currencyFormatter } from 'utils/formatter'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import styles from './style.css'
import DropdownSelect from './DropdownSelect'
import { onChangeSubscriptionRules, setTotalBillingPrice, onClickTurnButton } from 'actions/setting/billing'
import TurnOn from 'assets/images/turn_on.png'
import TurnOff from 'assets/images/turn_off.png'
import NotAvailableButton from 'assets/images/not-available-button.png'

class InformationWithTooltip extends Component {
  render () {
    let tooltip = <Tooltip id={this.props.id}>This outlet cannot be extended<br />unless the other outlets are<br />expired
      or all outlets have the<br />same billing date.</Tooltip>
    return <OverlayTrigger placement='top' overlay={tooltip}>
      <input type='image' src={NotAvailableButton} className={styles['not-available-button']}
        onClick={(e) => { e.preventDefault() }} />
    </OverlayTrigger>
  }
}

const BillingEachOutlet = (props) => {
  const {outlets, featurePrice, featureStatus, mokaPrice, currentRules, dispatch, isDeleted} = props

  const calculatePrice = (price, discount) => {
    return price - ((discount / 100) * price)
  }

  return <div>{_.map(outlets, (outlet) => {
    return <div key={outlet.id}>
      <div className='row'>
        <div className='col-md-1 col-xs-1 col-sm-1 col-lg-1'>
          {!outlet.is_available && <InformationWithTooltip />}
          {outlet.is_available && !isDeleted[outlet.id] && <input type='image' src={TurnOn}
            className={styles['turn-on-off']}
            onClick={(event) => {
              event.preventDefault()
              dispatch(onClickTurnButton(outlet.id, isDeleted))
            }} />}
          {outlet.is_available && isDeleted[outlet.id] && <input type='image' src={TurnOff}
            className={styles['turn-on-off']}
            onClick={(event) => {
              event.preventDefault()
              dispatch(onClickTurnButton(outlet.id, isDeleted))
            }} />}
        </div>
        <div className='col-md-4 col-xs-10 col-sm-5 col-lg-5'>
          <p className={`${currentRules.discount > 0 ? styles['outlet-name-elipsis'] : styles['outlet-name-mobi']} ${isDeleted[outlet.id] ? styles['inactive'] : ''}`}>
            <strong>{outlet.name}</strong>
          </p>
        </div>
        <div className='col-md-3 col-xs-6 col-sm-3 col-lg-3'>
          {
            currentRules.discount > 0 && <p className={`text-red text-left ${isDeleted[outlet.id] ? styles['inactive-red'] : ''}`}>
              <del>{currencyFormatter(mokaPrice)}</del>
            </p>
          }
        </div>
        <div className={`col-md-4 col-xs-6 col-sm-3 col-lg-3 ${currentRules.discount > 0 ? '' : styles['price-mobi']}`}>
          <p className={`pull-right ${isDeleted[outlet.id] ? styles['inactive'] : ''}`}>
            {currencyFormatter(calculatePrice(mokaPrice, currentRules.discount))}/mo
          </p>
        </div>
      </div>
      {
        _.map(featureStatus, (feature) => {
          if (feature.isFeatureNeedToBePaid) {
            return <div className='row'>
              <div className='col-md-1 col-xs-1 col-sm-1 col-lg-1' />
              <div className='col-md-4 col-xs-10 col-sm-5 col-lg-5'>
                <p className={`${isDeleted[outlet.id] ? styles['inactive'] : ''} ${styles['mb-0px']}`}>
                  <p className={currentRules.discount > 0 ? styles['feature-name'] : styles['feature-name-elipsis']}>{feature.name}</p>
                </p>
              </div>
              <div className='col-md-3 col-xs-6 col-sm-3 col-lg-3'>
                {
                  currentRules.discount > 0 && <p className={`text-red text-left ${isDeleted[outlet.id] ? styles['inactive-red'] : ''}`}>
                    <del>{feature.name === 'Loyalty' ? 'Rp. 250.000' : currencyFormatter(featurePrice[feature.name])}</del>
                  </p>
                }
              </div>
              <div className={`col-md-4 col-xs-6 col-sm-3 col-lg-3 ${currentRules.discount > 0 ? '' : styles['price-mobi']}`}>
                <p className={`pull-right ${isDeleted[outlet.id] ? styles['inactive'] : ''}`}>
                  {currencyFormatter(calculatePrice(featurePrice[feature.name], currentRules.discount))}/mo
                </p>
              </div>
            </div>
          }
        })
      }
    </div>
  })}</div>
}

class BillingReceiptForm extends Component {
  render () {
    let {rules, currentSubscriptionRules, handleSubmit, payButtonClicked, buttonMessage, pendingPaymentMessage, unusedOutletMessage, featureSubscriptionStatus, featureSubscriptionPrice, outlets, dispatch, isDeleted} = this.props
    let subscriptionRules = _.mapKeys(rules.subscription_plans, 'name')
    return (
      <div className={styles['billing-receipt-form-wrapper']}>
        <form onSubmit={handleSubmit}>
          <div className={styles['billing-receipt-slot']} />
          <div className={styles['billing-receipt-paper']}>
            <div className={styles['billing-receipt-paper-box']}>
              <div className='row'>
                <div className='col-md-3 col-sm-6'>
                  <span className={styles['text-vertically-aligned']}>Billing Cycle</span>
                </div>
                <div className='col-md-4 col-sm-6'>
                  <Field
                    name='subscriptionRules'
                    component={DropdownSelect}
                    options={subscriptionRules}
                    defaultOptionKey={{name: 'Moka 12 Months'}}
                    className='dropdown-select-subscription-rules'
                    id='changeSubscriptionRules'
                    onChange={this._onChangeSubscriptionRules}
                  />
                </div>
              </div>
            </div>
            <div className={styles['billing-receipt-paper-box']}>
              <h4 className={styles['mb-20px']}>OUTLETS : {this._calculateTotalOutlet()}</h4>
              <BillingEachOutlet
                outlets={outlets}
                featureStatus={featureSubscriptionStatus}
                featurePrice={featureSubscriptionPrice}
                mokaPrice={rules.moka_price}
                currentRules={currentSubscriptionRules}
                dispatch={dispatch}
                isDeleted={isDeleted}
              />
            </div>
            <div className={styles['billing-receipt-paper-box']}>
              {
                this._calculateTotalOutlet() > 0 && <div>
                  <div className={`text-primary row`}>
                    <div className='col-md-7 col-xs-6'>
                      <h4>{currentSubscriptionRules.month} Month{currentSubscriptionRules.month > 1 && 's'} Total</h4>
                    </div>
                    <div className='col-md-5 col-xs-6'>
                      <h4 className='pull-right'>{currencyFormatter(this._calculateTotalPrice())}</h4>
                    </div>
                  </div>
                  <div className={`row ${styles['mb-30px']}`}>
                    <div className='col-md-7 col-xs-6'>
                      <div className={styles['text-xs']}><em>Your expiration date will be extended to</em></div>
                      <div className={styles['text-xs']}><strong><em>{this._endOfNextPlan()}</em></strong></div>
                    </div>
                    <div className={`col-md-5 col-xs-6`}>
                      {
                        currentSubscriptionRules.discount > 0 &&
                        <div className={`pull-right ${styles['text-green']}`}>
                          <strong><em>Save {currentSubscriptionRules.discount}%</em></strong>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
              <div className='row'>
                <div className={`col-md-12 ${this._calculateTotalOutlet() !== 0 ? styles['btn-pay'] : ''}`}>
                  <button
                    className={`btn btn-lg btn-block ${this._calculateTotalOutlet() === 0 || payButtonClicked ? 'btn-disabled' : 'btn-primary'}`}
                    type='submit'
                    id='pay-button'
                    disabled={this._calculateTotalOutlet() === 0 || payButtonClicked}>
                    {buttonMessage}
                  </button>
                </div>
              </div>
              {
                pendingPaymentMessage !== null &&
                <div className={`row ${styles['mt-10px']} ${styles['text-xs']} text-red`}>
                  <div className='col-md-12'>
                    <em>{pendingPaymentMessage}</em>
                  </div>
                </div>
              }
              {
                unusedOutletMessage !== null &&
                <div className={`row ${styles['mt-10px']} ${styles['text-xs']} text-red`}>
                  <div className='col-md-12'>
                    <em>{unusedOutletMessage}</em>
                  </div>
                </div>
              }
            </div>
          </div>
        </form>
      </div>
    )
  }

  _onChangeSubscriptionRules = (event, subscriptionRules) => {
    const rules = _.mapKeys(this.props.rules.subscription_plans, 'name')
    this.props.dispatch(onChangeSubscriptionRules(rules[subscriptionRules]))
  }

  _calculateTotalOutlet = () => {
    const {outlets, isDeleted} = this.props
    let totalOutlets = 0
    _.map(outlets, (outlet) => { if (!isDeleted[outlet.id]) totalOutlets++ })
    return totalOutlets
  }

  _calculateTotalPrice = () => {
    let {currentSubscriptionRules, rules, featureSubscriptionStatus, featureSubscriptionPrice, outlets, isDeleted} = this.props
    if (!currentSubscriptionRules || !rules) {
      return 0
    }
    let totalPrice
    let activeOutletCount = 0
    let mokaPrice = (rules.moka_price - (currentSubscriptionRules.discount / 100) * rules.moka_price)
    let featurePrice = 0
    _.map(outlets, (outlet) => { if (!isDeleted[outlet.id]) activeOutletCount++ })
    _.forEach(featureSubscriptionStatus, (feature) => {
      if (feature.isFeatureNeedToBePaid) {
        featurePrice += (featureSubscriptionPrice[feature.name] - (currentSubscriptionRules.discount / 100) * featureSubscriptionPrice[feature.name])
      }
    })
    totalPrice = (mokaPrice + featurePrice) * activeOutletCount
    totalPrice = isNaN(totalPrice) ? 0 : totalPrice
    let monthRules = 0
    if (currentSubscriptionRules.month) {
      monthRules = currentSubscriptionRules.month
    }
    this.props.dispatch(setTotalBillingPrice(totalPrice * monthRules))
    return totalPrice * currentSubscriptionRules.month
  }

  _endOfNextPlan = () => {
    let {outlets, currentSubscriptionRules, expired, rules} = this.props
    if (expired) {
      let subscriptionPlans = rules.subscription_plans
      let monthRules = currentSubscriptionRules.month
      if (subscriptionPlans) {
        return subscriptionPlans.length === 1 ? moment().format('D MMMM YYYY') : moment().add(monthRules, 'month').format('D MMMM YYYY')
      } else {
        return moment().format('D MMMM YYYY')
      }
    } else {
      let dateCollection = []
      _.forEach(outlets, (outlet) => {
        dateCollection.push(
          new Date(moment(outlet.end_date).format('YYYY'),
            moment(outlet.end_date).format('MM') - 1,
            moment(outlet.end_date).format('DD'))
        )
      })
      const maxDate = moment(new Date(Math.max.apply(null, dateCollection))).format('DD/MM/YYYY')
      const minDate = moment(new Date(Math.min.apply(null, dateCollection))).format('DD/MM/YYYY')
      return maxDate !== minDate ? moment(new Date(Math.max.apply(null, dateCollection))).format('D MMMM YYYY') : moment(new Date(Math.max.apply(null, dateCollection))).add(currentSubscriptionRules.month, 'month').format('D MMMM YYYY')
    }
  }
}

const mapForm = {
  form: 'BillingReceipt'
}

function mapStateToProps (state) {
  let {outlets, rules, currentSubscriptionRules, pendingPaymentMessage, unusedOutletMessage, featureSubscriptionStatus, featureSubscriptionPrice, isDeleted} = state.setting.billing
  let {expired} = state.subscriptionExpired
  return {
    outlets,
    rules,
    currentSubscriptionRules,
    pendingPaymentMessage,
    unusedOutletMessage,
    featureSubscriptionStatus,
    featureSubscriptionPrice,
    expired,
    isDeleted
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(BillingReceiptForm))



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/Billing/BillingReceipt/BillingReceiptForm/BillingReceiptForm.js